module.exports = __webpack_public_path__ + "img/Graphics.1b045293.svg";